/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import { createRoot } from 'react-dom/client';
// Self-hosted variable fonts, trimmed to Latin + Greek subsets only.
import './fonts.css';
import App from './base/App';
import './i18n';

function start() {
  const root = createRoot(document.getElementById('root')!);
  root.render(<App />);
  console.log('React app started');
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', start);
} else {
  start();
}
